<template>
  <div id="banner">
    <img :src="bannerSrc" />
  </div>
</template>

<script>
export default {
  name: 'BannerDetail',
  props: {
    src: {
      type: String,
      required: true
    },
    mobileUrl: {
      type: String,
      default: ''
    }
  },
  computed: {
    bannerSrc() {
      // 简单判断：窗口宽度 ≤ 768 且传了 mobileUrl 就用 mobileUrl
      if (this.mobileUrl && window.innerWidth <= 768) {
        return this.mobileUrl;
      }
      return this.src;
    }
  },
  mounted() {
    // 响应式：窗口变化时重新计算
    window.addEventListener('resize', () => {
      // 触发计算属性重新求值
      this.$forceUpdate();
    });
  }
};
</script>

<style scoped>
#banner {
  width: 100%;
  height: 26.05vw;
}
#banner img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

@media (max-width: 768px) {
  #banner {
    height: auto;
  }
  #banner img {
    height: auto;
  }
}
</style>
